// extracted by mini-css-extract-plugin
export default {"background":"Navbar_background__7w8Qd","links":"Navbar_links__aQqlv","active":"Navbar_active__cy5tg","title":"Navbar_title__T7MOj"};